import { ReactNode } from 'react'

const Placeholder = (props: { children: ReactNode }) => (
  <div className='placeholder'>{props.children}</div>
)
export default Placeholder
